module.exports = "<ul class=\"popover-content-container\">\n    <li ng-repeat=\"tool in topNav.proposalTools\" ng-click=\"topNav.toolClick(tool)\">\n        <span>{{tool}}</span>\n    </li>\n</ul>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/common/topNav/popovers/proposalOptions.html
// module id = 953
// module chunks = 1